import { Box, Divider, Flex, Icon, Spinner, Stack, Text, useToast, Progress } from '@chakra-ui/react';
import { Button, useBreakpointValue } from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';
import React, { useState, useEffect, useRef } from 'react';
import { FaCheck } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import moment from 'moment';
import Holidays from 'date-holidays';

import SearchHotelCard from './SearchHotelCard';
// import MapSearchBar from './MapSearchBar';
import MapSearchBar from './MapSearchBarOSM';
import SearchFilterBar from './SearchFilterBar';
// import Map from './Map';

// Safe import for Map component with fallback
let MapComponent;
try {
  MapComponent = require('./MapOSM').default;
} catch (error) {
  console.warn('MapOSM import failed, using fallback:', error);
  // Fallback Map component
  MapComponent = ({ centeredLocation, hotelCoords }) => (
    <Box 
      width="100%" 
      height="100%" 
      bg="gray.200" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
    >
      <Text>Map component unavailable</Text>
    </Box>
  );
}

const MapSearchPage = () => {
  const hd = new Holidays();
  hd.init('US');

  const holidayStartDate = moment().add(2, 'days').toDate();
  const holidayEndDate = moment().add(180, 'days').toDate();

  const startYear = holidayStartDate.getFullYear();
  const endYear = holidayEndDate.getFullYear();

  let holidays = [];

  // Get holidays for the current year and the next if the range spans over two years
  for (let year = startYear; year <= endYear; year++) {
    holidays = [...holidays, ...hd.getHolidays(year)];
  }

  // Filter holidays to future public holidays
  const filteredHolidays = holidays.filter(holiday => {
    const holidayDate = new Date(holiday.date);
    return holidayDate > holidayStartDate && holiday.type === 'public';
  });

  // make start date as the day before the first public holiday
  const startDate = moment(filteredHolidays[0].date).add(-1, 'days').toDate();
  const endDate = moment(startDate).add(2, 'days').toDate();
  // setSelectedDates([startDate, endDate]);
  // setCenter({ lat: 21.161908, lng: -86.8515279 });
  // setBounds([21.02976323827379,21.2130332751345,-86.97226755449996,-86.74054014055625]);
  // setCenteredLocation({ lat: 21.161908, lng: -86.8515279 });
  // console.log(center, bounds, centeredLocation)
  // handleSearch(startDate, endDate, { label: 'Cancun, Quintana Roo, Mexico' });

  const [maxPrice, setMaxPrice] = useState(4000);
  const [maxPoints, setMaxPoints] = useState(1000000);
  const brandOptions = ['Hilton', 'Hyatt', 'IHG', 'Marriott'];
  const [brandCount, setBrandCount] = useState({
    'Hilton': 0,
    'Hyatt': 0,
    'IHG': 0,
    'Marriott': 0
  });
  const [subBrandOptions, setSubBrandOptions] = useState({});
  const [subBrandCount, setSubBrandCount] = useState({});

  const [centeredLocation, setCenteredLocation] = useState({ lat: 21.161908, lng: -86.8515279 });
  const [bounds, setBounds] = useState([21.02976323827379, 21.2130332751345, -86.97226755449996, -86.74054014055625]);
  const [center, setCenter] = useState({ lat: 21.161908, lng: -86.8515279 });
  const [hotelCoords, setHotelCoords] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [searchTrigger, setSearchTrigger] = useState(0);

  const [allHotels, setAllHotels] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);

  const [priceRange, setPriceRange] = useState([0, maxPrice]);
  const [pointsRange, setPointsRange] = useState([0, maxPoints]);
  const [priceRangeSlider, setPriceRangeSlider] = useState([0, 100]);
  const [pointsRangeSlider, setPointsRangeSlider] = useState([0, 100]);

  const [nameFilter, setNameFilter] = useState('');
  const [sortBy, setSortBy] = useState('Popularity');


  const [brands, setBrands] = useState(['Hilton', 'Hyatt', 'IHG', 'Marriott']);
  const [subBrands, setSubBrands] = useState({});
  const [brandsLoaded, setBrandsLoaded] = useState(4);

  const [selectedDates, setSelectedDates] = useState([startDate, endDate]);


  const [isLoading, setIsLoading] = useState({
    'Hilton': false,
    'Hyatt': false,
    'IHG': false,
    'Marriott': false
  });

  const [isError, setIsError] = useState({
    'Hilton': false,
    'Hyatt': false,
    'IHG': false,
    'Marriott': false
  });

  // Add progress tracking state
  const [brandProgress, setBrandProgress] = useState({
    'Hilton': 0,
    'Hyatt': 0,
    'IHG': 0,
    'Marriott': 0
  });

  const filterRenders = useRef(0);
  const subBrandRenders = useRef(0);
  const initialRenders = 2;
  const prevCenterRef = useRef(null);

  const errorToast = useToast();

  const [controller, setController] = useState();
  const signal = useRef();


  const [viewMode, setViewMode] = useState(useBreakpointValue({ base: 'card', md: 'both', lg: 'both', xl: 'both', '2xl': 'both' }, { ssr: false })); // 'card' or 'map' or 'both'
  const showButton = useBreakpointValue({ base: true, md: false });

  const toggleViewMode = () => {
    setViewMode(viewMode === 'card' ? 'map' : 'card');
  };

  useEffect(() => {
    handleSearch(startDate, endDate, { label: 'Cancun, Quintana Roo, Mexico', formatted_address: 'Cancun, Quintana Roo, Mexico' });
  }, []);

  // Update centeredLocation only when user selects a new location (center changes)
  // This ensures the map recenters when searching for a new location, but not when hotels are fetched
  useEffect(() => {
    // Only update if center actually changed (compare values, not reference)
    const centerChanged = !prevCenterRef.current || 
      prevCenterRef.current.lat !== center.lat || 
      prevCenterRef.current.lng !== center.lng;
    
    if (centerChanged) {
      prevCenterRef.current = center;
      setCenteredLocation(center);
    }
  }, [center]);

  const fetchHotels = async (checkinDate, checkoutDate, searchedLocation) => {
    try {
      if (controller) {
        controller.abort();
      }
      const newController = new AbortController();
      setController(newController);
      signal.current = newController.signal;

      const formattedLocation = encodeURIComponent(searchedLocation.formatted_address.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
      const formattedBounds = encodeURIComponent(bounds);
      const formattedCenter = encodeURIComponent(`${center.lat},${center.lng}`);
      const fetchPromises = brandOptions.map(async (brand) => {
        // const url = `http://127.0.0.1:5000/api/search?cpi=${formattedLocation}&ci=${checkinDate}&co=${checkoutDate}&b=${formattedBounds}&na=2&nr=1&c=${formattedCenter}&brand=${brand}`;
        const url = `https://service.maxmypoint.com/search?cpi=${formattedLocation}&ci=${checkinDate}&co=${checkoutDate}&b=${formattedBounds}&na=2&nr=1&c=${formattedCenter}&brand=${brand}`;
        return fetchHotel(url, brand);
      });

      await Promise.allSettled(fetchPromises);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching hotels:', error);
      }
    }
  }

  // Create skeleton placeholder hotels for a brand
  const createSkeletonHotels = (brand, count = 5) => {
    const skeletons = [];
    for (let i = 0; i < count; i++) {
      skeletons.push({
        id: `skeleton-${brand}-${i}`,
        n: `Loading ${brand} Hotel ${i + 1}...`,
        b: brand,
        sb: `${brand} Hotels`,
        pr: undefined, // undefined = skeleton
        pt: undefined, // undefined = skeleton
        v: undefined,  // undefined = skeleton
        g: [center.lat + (Math.random() - 0.5) * 0.1, center.lng + (Math.random() - 0.5) * 0.1],
        i: '',
        qc: 0
      });
    }
    return skeletons;
  };

  const fetchHotel = async (url, brand) => {
    try {
      // Add skeleton placeholders initially
      const skeletonHotels = createSkeletonHotels(brand);
      setAllHotels(prevHotels => {
        const filteredHotels = prevHotels.filter(h => h.b !== brand);
        return [...filteredHotels, ...skeletonHotels];
      });

      for (let i = 0; i < 50; i++) {
        // Check if request was aborted before making the fetch
        if (signal.current.aborted) {
          throw new Error('AbortError');
        }

        const response = await fetch(url, { signal: signal.current });
        if (response.ok) {
          const data = await response.json();
          
          // Handle new API format with status field
          if (data.status && data.status.status === 'in_progress') {
            // Update progress
            const progressPercent = (data.status.completed / data.status.total) * 100;
            setBrandProgress(prevProgress => ({ 
              ...prevProgress, 
              [brand]: progressPercent 
            }));
            
            // Always update hotels based on current results
            if (data.r && data.r.length > 0) {
              // Process all hotels, marking pricing data appropriately
              data.r.forEach(hotel => {
                // Check if we have valid numeric pricing data
                const hasValidPrice = hotel.pr !== null && hotel.pr !== 'N/A' && typeof hotel.pr === 'number' && !isNaN(hotel.pr) && hotel.pr > 0;
                const hasValidPoints = hotel.pt !== null && hotel.pt !== 'N/A' && typeof hotel.pt === 'number' && !isNaN(hotel.pt) && hotel.pt > 0;
                
                if (hasValidPrice && hasValidPoints) {
                  hotel.v = hotel.pr * 100 / hotel.pt;
                } else if (hotel.pr === null || hotel.pt === null) {
                  if (hotel.pr === null) hotel.pr = undefined;
                  if (hotel.pt === null) hotel.pt = undefined;
                  
                  if (hotel.pr !== undefined && hotel.pt !== undefined && 
                      typeof hotel.pr === 'number' && typeof hotel.pt === 'number' &&
                      !isNaN(hotel.pr) && !isNaN(hotel.pt) && hotel.pr > 0 && hotel.pt > 0) {
                    hotel.v = hotel.pr * 100 / hotel.pt;
                  } else {
                    hotel.v = undefined;
                  }
                } else {
                  // Handle 'N/A' values or invalid data - ensure they stay as 'N/A' string
                  if (hotel.pr === 'N/A' || (typeof hotel.pr !== 'number' || isNaN(hotel.pr) || hotel.pr <= 0)) {
                    hotel.pr = 'N/A';
                  }
                  if (hotel.pt === 'N/A' || (typeof hotel.pt !== 'number' || isNaN(hotel.pt) || hotel.pt <= 0)) {
                    hotel.pt = 'N/A';
                  }
                  hotel.v = 'N/A';
                }
              });
              
              // Remove all existing hotels for this brand before adding new ones
              setAllHotels(prevHotels => {
                const filteredHotels = prevHotels.filter(h => h.b !== brand);
                return [...filteredHotels, ...data.r];
              });
              
              // Update brand count with partial results
              setBrandCount(prevBrandCount => ({ 
                ...prevBrandCount, 
                [brand]: data.r.length 
              }));
            } else if (data.r && data.r.length === 0) {
              // Remove all hotels for this brand when results are empty
              setAllHotels(prevHotels => prevHotels.filter(h => h.b !== brand));
              
              // Update brand count to 0
              setBrandCount(prevBrandCount => ({ 
                ...prevBrandCount, 
                [brand]: 0 
              }));
            }
            
            // Keep loading state as true for in_progress status
            setIsLoading(prevLoading => ({ ...prevLoading, [brand]: true }));
            
            // Check if aborted before waiting
            if (signal.current.aborted) {
              throw new Error('AbortError');
            }
            
            await new Promise((resolve, reject) => {
              const timeout = setTimeout(resolve, 6000);
              // Cancel the timeout if the request is aborted
              signal.current.addEventListener('abort', () => {
                clearTimeout(timeout);
                reject(new Error('AbortError'));
              });
            });
            continue;
          }
          
          // Handle completed status
          if ((data.status && data.status.status === 'completed') || !data.status) {
            if (data.r && data.r.length > 0) {
              // Process hotel data
              data.r.forEach(hotel => {
                const hasValidPrice = hotel.pr !== null && hotel.pr !== 'N/A' && typeof hotel.pr === 'number' && !isNaN(hotel.pr) && hotel.pr > 0;
                const hasValidPoints = hotel.pt !== null && hotel.pt !== 'N/A' && typeof hotel.pt === 'number' && !isNaN(hotel.pt) && hotel.pt > 0;
                
                if (hasValidPrice && hasValidPoints) {
                  hotel.v = hotel.pr * 100 / hotel.pt;
                } else if (hotel.pr === null || hotel.pt === null) {
                  if (hotel.pr === null) hotel.pr = undefined;
                  if (hotel.pt === null) hotel.pt = undefined;
                  
                  if (hotel.pr !== undefined && hotel.pt !== undefined && 
                      typeof hotel.pr === 'number' && typeof hotel.pt === 'number' &&
                      !isNaN(hotel.pr) && !isNaN(hotel.pt) && hotel.pr > 0 && hotel.pt > 0) {
                    hotel.v = hotel.pr * 100 / hotel.pt;
                  } else {
                    hotel.v = undefined;
                  }
                } else {
                  // Handle 'N/A' values or invalid data - ensure they stay as 'N/A' string
                  if (hotel.pr === 'N/A' || (typeof hotel.pr !== 'number' || isNaN(hotel.pr) || hotel.pr <= 0)) {
                    hotel.pr = 'N/A';
                  }
                  if (hotel.pt === 'N/A' || (typeof hotel.pt !== 'number' || isNaN(hotel.pt) || hotel.pt <= 0)) {
                    hotel.pt = 'N/A';
                  }
                  hotel.v = 'N/A';
                }
              });
              
              // Remove all existing hotels for this brand (including loading skeletons) before adding final results
              setAllHotels(prevHotels => {
                const filteredHotels = prevHotels.filter(h => h.b !== brand);
                return [...filteredHotels, ...data.r];
              });
              
              setIsLoading(prevLoading => ({ ...prevLoading, [brand]: false }));
              setBrandsLoaded(prevBrandsLoaded => prevBrandsLoaded + 1);
              setBrandCount(prevBrandCount => ({ ...prevBrandCount, [brand]: data.r.length }));
              setBrandProgress(prevProgress => ({ 
                ...prevProgress, 
                [brand]: 100 
              }));
              return data.r;
            }
          }
          
          // Handle error cases
          if (data.r && (data.r.error || !data.r || data.r === 'undefined')) {
            setIsError(prevError => ({ ...prevError, [brand]: true }));
            errorToast({
              title: `Error searching for ${brand} hotels`,
              description: 'Please try again',
              variant: 'subtle',
              status: 'error',
              duration: 9000,
              isClosable: true
            });
            
            setIsLoading(prevLoading => ({ ...prevLoading, [brand]: false }));
            setBrandsLoaded(prevBrandsLoaded => prevBrandsLoaded + 1);
            setBrandCount(prevBrandCount => ({ ...prevBrandCount, [brand]: 0 }));
            setBrandProgress(prevProgress => ({ 
              ...prevProgress, 
              [brand]: 100 
            }));
            
            setAllHotels(prevHotels => prevHotels.filter(h => 
              !(h.b === brand && h.n.startsWith('Loading'))
            ));
            return [];
          }
        }
      }
      
      // All retries exhausted
      setIsError(prevError => ({ ...prevError, [brand]: true }));
      errorToast({
        title: `Searching ${brand} has no hotels returned.`,
        description: 'Please change the location and try again. If this error persists, please contact info@maxmypoint.com.',
        variant: 'subtle',
        status: 'error',
        duration: 9000,
        isClosable: true
      });
      
      setIsLoading(prevLoading => ({ ...prevLoading, [brand]: false }));
      setBrandsLoaded(prevBrandsLoaded => prevBrandsLoaded + 1);
      setBrandProgress(prevProgress => ({ 
        ...prevProgress, 
        [brand]: 100 
      }));
      
      setAllHotels(prevHotels => prevHotels.filter(h => 
        !(h.b === brand && h.n.startsWith('Loading'))
      ));
      throw new Error('Error fetching hotels');
      
    } catch (err) {
      if (err.name === 'AbortError' || err.message === 'AbortError') {
        console.log(`${brand} fetch aborted`);
        return;
      } else {
        console.error('Error fetching hotels:', err);
        setIsLoading(prevLoading => ({ ...prevLoading, [brand]: false }));
        setBrandsLoaded(prevBrandsLoaded => prevBrandsLoaded + 1);
        setBrandProgress(prevProgress => ({ 
          ...prevProgress, 
          [brand]: 100 
        }));
        
        setAllHotels(prevHotels => prevHotels.filter(h => 
          !(h.b === brand && h.n.startsWith('Loading'))
        ));
      }
    }
  }


  const filterHotels = () => {
    if (allHotels.length === 0) {
      setFilteredHotels([]);
      return;
    }
    
    const newFilteredHotels = allHotels.filter(hotel => {
      if (Object.keys(subBrandOptions).length === 0 && !hotel.n.startsWith('Loading')) {
        return false;
      }
      
      const isPriceInRange = hotel.pr === undefined || hotel.pr === null || hotel.pr === 'N/A' || !hotel.pr || (typeof hotel.pr === 'number' && hotel.pr >= priceRange[0] && hotel.pr <= priceRange[1]);
      const isPointsInRange = hotel.pt === undefined || hotel.pt === null || hotel.pt === 'N/A' || !hotel.pt || (typeof hotel.pt === 'number' && hotel.pt >= pointsRange[0] && hotel.pt <= pointsRange[1]);
      const isSubBrandIncluded = subBrands && subBrands[hotel.b] && subBrands[hotel.b].includes(hotel.sb);
      const isNameIncluded = !nameFilter || hotel.n.toLowerCase().includes(nameFilter.toLowerCase().trim());
      
      return isPriceInRange && isPointsInRange && isSubBrandIncluded && isNameIncluded;
    });

    const newSortedHotels = newFilteredHotels.sort((a, b) => {
      // Put loading hotels at the end
      if (a.n.startsWith('Loading') && !b.n.startsWith('Loading')) return 1;
      if (!a.n.startsWith('Loading') && b.n.startsWith('Loading')) return -1;
      if (a.n.startsWith('Loading') && b.n.startsWith('Loading')) {
        return a.b.localeCompare(b.b);
      }
      
      // Update sorting to handle -1 as N/A indicator
      const handleNonNumeric = (a, b) => {
        // Check if values are non-numeric or -1 (our N/A indicator)
        const aIsNonNumeric = a === null || a === undefined || a === -1 || typeof a !== 'number' || isNaN(a);
        const bIsNonNumeric = b === null || b === undefined || b === -1 || typeof b !== 'number' || isNaN(b);
        
        if (aIsNonNumeric && bIsNonNumeric) return 0; // Both non-numeric, treat as equal
        if (aIsNonNumeric) return 1; // a is non-numeric, b is numeric, a should come after b
        if (bIsNonNumeric) return -1; // b is non-numeric, a is numeric, a should come before b
        return null; // Both are numeric, proceed to normal comparison
      };

      if (sortBy === 'Popularity') {
        const nonNumericComparison = handleNonNumeric(a.qc, b.qc);
        if (nonNumericComparison !== null) return nonNumericComparison;
        return b.qc - a.qc;
      } else if (sortBy === 'Lowest Points') {
        const nonNumericComparison = handleNonNumeric(a.pt, b.pt);
        if (nonNumericComparison !== null) return nonNumericComparison;
        return a.pt - b.pt;
      } else if (sortBy === 'Lowest Price') {
        const nonNumericComparison = handleNonNumeric(a.pr, b.pr);
        if (nonNumericComparison !== null) return nonNumericComparison;
        return a.pr - b.pr;
      } else if (sortBy === 'Highest Value') {
        const nonNumericComparison = handleNonNumeric(a.v, b.v);
        if (nonNumericComparison !== null) return nonNumericComparison;
        return b.v - a.v;
      } else if (sortBy === 'Highest Price') {
        const nonNumericComparison = handleNonNumeric(a.pr, b.pr);
        if (nonNumericComparison !== null) return nonNumericComparison;
        return b.pr - a.pr;
      }
    });

    setFilteredHotels(newSortedHotels);
    const newHotelCoords = [];
    for (let hotel of newFilteredHotels) {
      if (!hotel.n.startsWith('Loading')) {
        newHotelCoords.push({
          name: hotel.n,
          lat: hotel.g[0],
          lng: hotel.g[1],
          key: hotel.id,
          points: hotel.pt,
          price: hotel.pr,
          i: hotel.i,
          v: hotel.v
        });
      }
    }
    setHotelCoords(newHotelCoords);
  }

  // Generate sub brand options for filters based on fetched hotel data and brand filters
  const generateSubBrand = () => {
    const dataSubBrands = {};
    const dataSubBrandsCount = {};
    for (let brand of brands) {
      dataSubBrands[brand] = [];
      dataSubBrandsCount[brand] = {};
    }

    // Add skeleton sub-brands first to ensure filtering works
    for (let brand of brands) {
      const skeletonSubBrand = `${brand} Hotels`;
      if (!dataSubBrands[brand].includes(skeletonSubBrand)) {
        dataSubBrands[brand].push(skeletonSubBrand);
        dataSubBrandsCount[brand][skeletonSubBrand] = 0;
      }
    }

    for (let hotel of allHotels) {
      if (dataSubBrands[hotel.b]) {
        if (!dataSubBrands[hotel.b].includes(hotel.sb)) {
          dataSubBrands[hotel.b].push(hotel.sb);
          dataSubBrandsCount[hotel.b][hotel.sb] = 1;
        } else {
          dataSubBrandsCount[hotel.b][hotel.sb] += 1;
        }
      }
    }
    
    const sortedDataSubBrands = Object.keys(dataSubBrands)
      .sort()
      .reduce((obj, key) => {
        obj[key] = dataSubBrands[key];
        return obj;
      }, {});
    setSubBrandOptions(sortedDataSubBrands);
    setSubBrandCount(dataSubBrandsCount);
    setSubBrands(sortedDataSubBrands);
  }

  // Generate max price and points for range sliders based on fetched hotel data
  const generateMaxFilters = () => {
    let newMaxPrice = 0;
    let newMaxPoints = 0;
    for (let hotel of allHotels) {
      // Skip skeleton hotels when calculating max filters
      if (hotel.n.startsWith('Loading')) continue;
      
      if (hotel.pr && hotel.pr > newMaxPrice) {
        newMaxPrice = hotel.pr;
      }
      if (hotel.pt && hotel.pt > newMaxPoints) {
        newMaxPoints = hotel.pt;
      }
    }
    setMaxPrice(newMaxPrice);
    setMaxPoints(newMaxPoints);
    setPriceRange([0, newMaxPrice]);
    setPointsRange([0, newMaxPoints]);
  }

  // Fetch hotel data when searched
  const handleSearch = (checkinDate, checkoutDate, searchedLocation) => {
    checkinDate = moment(checkinDate).format('YYYY-MM-DD')
    checkoutDate = moment(checkoutDate).format('YYYY-MM-DD')

    let errorMessages = [];
    if (!searchedLocation) {
      errorMessages.push('location with the autocomplete dropdown');
    }
    if (!checkinDate || Date.parse(checkinDate) < Date.now()) {
      errorMessages.push('check in date');
    }
    if (!checkoutDate || Date.parse(checkoutDate) < Date.now() || Date.parse(checkoutDate) <= Date.parse(checkinDate)) {
      errorMessages.push('check out date');
    }
    if (errorMessages.length > 0) {
      errorToast({
        title: 'Error searching for hotels',
        description: 'Please enter a valid ' + errorMessages.join(', '),
        variant: 'subtle',
        status: 'error',
        duration: 9000,
        isClosable: true,
        position: 'top'
      });
    }
    else {
      // Clear all existing data immediately when new search starts
      setAllHotels([]);
      setFilteredHotels([]);
      setHotelCoords([]);
      setSelectedHotel(null);
      
      // Reset brand counts and states
      setBrandCount({
        'Hilton': 0,
        'Hyatt': 0,
        'IHG': 0,
        'Marriott': 0
      });
      setIsLoading({
        'Hilton': true,
        'Hyatt': true,
        'IHG': true,
        'Marriott': true
      });
      setIsError({
        'Hilton': false,
        'Hyatt': false,
        'IHG': false,
        'Marriott': false
      });
      setBrandProgress({
        'Hilton': 0,
        'Hyatt': 0,
        'IHG': 0,
        'Marriott': 0
      });
      setBrandsLoaded(0);

      // Reset sub-brand data to ensure clean state
      setSubBrandOptions({});
      setSubBrandCount({});
      
      // Reset filters
      setPriceRange([0, maxPrice]);
      setPointsRange([0, maxPoints]);
      setPriceRangeSlider([0, 100]);
      setPointsRangeSlider([0, 100]);
      setBrands(['Hilton', 'Hyatt', 'IHG', 'Marriott']);
      setSubBrands({});
      setNameFilter('');

      // Ensure map flies to the target location when search is clicked
      // Update centeredLocation to trigger map fly animation
      setCenteredLocation(center);
      // Increment search trigger to force map to fly even if location is the same
      setSearchTrigger(prev => prev + 1);

      fetchHotels(checkinDate, checkoutDate, searchedLocation);
    }
  }


  const getHotelData = (hotelId) => {
    //console.log('gethoteldata', hotelId, allHotels)
    return allHotels.find(hotel => hotel.id == hotelId);
  }

  // Handle hotel card click - center map on hotel and show it
  const handleHotelCardClick = (hotel) => {
    if (hotel && hotel.g && hotel.g.length >= 2 && !hotel.n.startsWith('Loading')) {
      const hotelLocation = { lat: hotel.g[0], lng: hotel.g[1] };
      
      // Find the hotel in hotelCoords to get full data for popup
      const hotelCoord = hotelCoords.find(h => h.key === hotel.id);
      if (hotelCoord) {
        setSelectedHotel({
          name: hotel.n,
          lat: hotel.g[0],
          lng: hotel.g[1],
          key: hotel.id,
          points: hotel.pt,
          price: hotel.pr,
          i: hotel.i,
          v: hotel.v
        });
      }
      
      // Center the map on the hotel
      setCenteredLocation(hotelLocation);
    }
  }

  useEffect(() => {
    if (subBrandRenders.current < initialRenders) {
      subBrandRenders.current++;
      return;
    }
    generateSubBrand();
    generateMaxFilters();
  }, [brands, allHotels]);

  useEffect(() => {
    if (filterRenders.current < initialRenders) {
      filterRenders.current++;
      return;
    }
    filterHotels();
  }, [priceRange, pointsRange, subBrands, nameFilter, sortBy, allHotels]);

  // Calculate brand-specific result counts for display
  const getResultSummary = () => {
    const totalResults = filteredHotels.length;
    const brandsWithResults = Object.keys(brandCount).filter(brand => brandCount[brand] > 0);
    
    if (brandsWithResults.length === 0) {
      return `${totalResults} Results`;
    } else if (brandsWithResults.length === 1) {
      return `${totalResults} Results with ${brandsWithResults[0]}`;
    } else {
      return `${totalResults} Results with ${brandsWithResults.length} Brands`;
    }
  };

  return (
    <Flex direction='row' height='100%'>
      <Flex direction='column' px={6} width={['100%', 'container.md']} height='calc(100vh - 50px)' gap={1}>
        <MapSearchBar
          handleSearch={handleSearch}
          setBounds={setBounds}
          setCenter={setCenter}
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
        />
        <Progress value={100 * (brandsLoaded / 4)} hasStripe size='md'/>
        {/* <Divider borderColor='gray.500' mb={2} /> */}
        <SearchFilterBar
          resultCount={getResultSummary()}
          brands={brands}
          brandCount={brandCount}
          setBrands={setBrands}
          subBrandOptions={subBrandOptions}
          subBrandCount={subBrandCount}
          subBrands={subBrands}
          setSubBrands={setSubBrands}
          maxPrice={maxPrice}
          setPriceRange={setPriceRange}
          maxPoints={maxPoints}
          setPointsRange={setPointsRange}
          priceRangeSlider={priceRangeSlider}
          setPriceRangeSlider={setPriceRangeSlider}
          pointsRangeSlider={pointsRangeSlider}
          setPointsRangeSlider={setPointsRangeSlider}
          nameFilter={nameFilter}
          setNameFilter={setNameFilter}
          sortBy={sortBy}
          setSortBy={setSortBy}
          brandsLoaded={brandsLoaded}
        />
      {showButton && (
        <Button
          leftIcon={<ViewIcon />}
          position="fixed"
          bottom="20px"
          left="50%"
          transform="translateX(-50%)"
          zIndex="overlay"
          colorScheme="teal"
          aria-label="Toggle View"
          onClick={toggleViewMode}
        >
          {viewMode === 'card' ? 'View Map' : 'View List'}
        </Button>
      )}
        {(viewMode === 'card' || viewMode === 'both') && (
        <Stack overflowY='auto' mt={3} flexGrow='1' align='center' width='100%'>
          <Stack direction='column' gap={3} justify='center' width='100%'>
            {allHotels.length > 0 && filteredHotels.map((hotel) => {
  // Create a clean copy to avoid mutating the original hotel object during render
  const hotelData = { ...hotel };
  
  // Ensure value calculation is correct before passing to SearchHotelCard
  if (typeof hotelData.pr === 'number' && typeof hotelData.pt === 'number' && 
      !isNaN(hotelData.pr) && !isNaN(hotelData.pt) && hotelData.pr > 0 && hotelData.pt > 0) {
    // Both price and points are valid numbers - calculate value
    const calculatedValue = hotelData.pr * 100 / hotelData.pt;
    hotelData.v = isNaN(calculatedValue) ? undefined : calculatedValue;
  } else if (hotelData.pr === 'N/A' || hotelData.pt === 'N/A') {
    // Either price or points is N/A - set value to N/A
    hotelData.v = 'N/A';
  } else {
    // Any other case - set to undefined for skeleton
    hotelData.v = undefined;
  }
  
  // Final safety check - force any invalid values to undefined
  if (hotelData.v !== undefined && hotelData.v !== 'N/A') {
    if (typeof hotelData.v !== 'number' || isNaN(hotelData.v) || !isFinite(hotelData.v)) {
      hotelData.v = undefined;
    }
  }
  
  // Also ensure pr and pt are safe
  if (hotelData.pr !== undefined && hotelData.pr !== 'N/A' && (typeof hotelData.pr !== 'number' || isNaN(hotelData.pr))) {
    hotelData.pr = undefined;
  }
  if (hotelData.pt !== undefined && hotelData.pt !== 'N/A' && (typeof hotelData.pt !== 'number' || isNaN(hotelData.pt))) {
    hotelData.pt = undefined;
  }
  
              return (
                <SearchHotelCard
                  width={{ base: "100%", md: "100%" }}
                  id={hotel.id}
                  key={hotel.id}
                  hotel={hotelData}
                  onCardClick={() => handleHotelCardClick(hotel)}
                />
              );
            })}
          </Stack>
          {allHotels.length === 0 && (
            <>
              <Spinner size='xl' color='blue.500' mt={4} />
              <Text>Loading hotels...</Text>
            </>
          )}
        </Stack>
        )}
      {(viewMode === 'map') && (
        <MapComponent
          centeredLocation={centeredLocation}
          hotelCoords={hotelCoords}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          searchTrigger={searchTrigger}
          // getHotelData={getHotelData}
        />
      )}
        <Divider borderColor='gray.500' mt={2} />
        <Stack direction='row' mb={3} px={3} py={1}>
          <Text whiteSpace='nowrap'>Search progress:</Text>
          <Flex direction='row' justify='space-around' width='100%'>
            {Object.keys(isLoading).map((brand) => (
              <Stack key={brand} direction='row' gap={2} align='center'>
                <Text>{brand}</Text>
                {isError[brand] && <Icon as={FaXmark} color='red.500' />}
                {!isError[brand] && isLoading[brand] && (
                  <Stack direction='row' align='center' gap={1}>
                    <Spinner color='blue.500' size='sm' />
                    <Text fontSize='sm'>{Math.round(brandProgress[brand])}%</Text>
                  </Stack>
                )}
                {!isError[brand] && !isLoading[brand] && <Icon as={FaCheck} color='blue.500' />}
              </Stack>
            ))}
          </Flex>
        </Stack>
      </Flex>
      {(viewMode === 'both') && (
        <MapComponent
          centeredLocation={centeredLocation}
          hotelCoords={hotelCoords}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          searchTrigger={searchTrigger}
          // getHotelData={getHotelData}
        />
      )}
    </Flex>
  );
};

export default MapSearchPage;
